module.exports = __webpack_public_path__ + "img/edit-deactive.d0b16a58.svg";